import React from "react";
import OceanDashboard from "../OceanTMS/OceanDashboard";

// Air dashboard, Ocean ile aynı bileşenleri air moduyla kullanır (bkz. OceanTMS/transportModes.js)
function AirDashboard({ embedded = false }) {
    return <OceanDashboard embedded={embedded} mode="air" />;
}

export default AirDashboard;
